import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCreateLegalClientMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseLegalClient } from 'api/helpers/legal/parseLegalClient';
import { parseCreateLegalClientParam } from 'api/helpers/legal/parseParam';
import { CreateLegalClientParam } from 'api/types/params';

export const useCreateLegalClient = () => {
  const [createClient, { loading, error: apolloError }] =
    useCreateLegalClientMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    createClient: useCallback(
      async (param: CreateLegalClientParam) => {
        const input = parseCreateLegalClientParam(param);
        const res = await createClient({ variables: { input } });

        if (res.data?.legalClient) {
          return parseLegalClient(res.data.legalClient);
        }

        return undefined;
      },
      [createClient]
    ),
  };
};
